/* eslint-disable prefer-destructuring */
/* eslint-disable no-case-declarations */
import { getActiveState } from '../utils';
import * as types from './types';
import { multiSelectOptions } from '../../filterTable/filters';
// logica de cambio de casilleros
function crossInboxReducer(state, action) {
  switch (action.type) {
    case types.CHANGE_INBOX:
      const filteredOptions = multiSelectOptions.filter(option => option.tabFilter === 1);
      Object.keys(state.inbox.state).forEach(key => {
        state.inbox.state[key].active = key === action.payload;
      });
      state.inbox.status = getActiveState(state.inbox.state).status;
      let actionType = [];
      if (state.inbox.status === 'nondiscarded') {
        actionType = filteredOptions;
      }
      state.filterStatus.filtersSelected = [];
      state.filterTable.multiSelectOptions = state.filterTable.multiSelectOptions.map(op => {
        op.selected = false;
        return op;
      });
      state.filterTable.sortOptionSelected = state.filterTable.sortOptions[0];
      state.filterTable.checkedStatus = 'none';
      state.table.params.status = state.inbox.status;
      state.table.leads = [];
      state.table.params = {
        ...state.table.params,
        actionType,
        textSearch: '',
        offset: 0
      };
      return { ...state };
    default:
      return { ...state };
  }
}

export default crossInboxReducer;
